import clsx from 'clsx';
import React from 'react';
import Button from '../Button';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import ReportFileFilledIcon from '../../assets/icons/report-file-filled-icon.svg?react';

interface AlreadySubmittedToOshaProps {
  otherClasses?: string;
  currentYear: string;
}

const AlreadySubmittedToOsha: React.FC<AlreadySubmittedToOshaProps> = ({
  otherClasses,
  currentYear,
}) => {
  const noDepartmentClasses = clsx(
    otherClasses,
    'bg-light-neutral-tones-text/30 absolute flex flex-col left-0 top-0 h-screen w-full items-center justify-center backdrop-blur-xs md:px-0 px-4',
  );

  return (
    <div className={noDepartmentClasses} data-testid="no-department">
      <div className="flex max-w-3xl flex-col items-center px-4 text-center">
        <WarningIcon className="[&>g>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-neutral-tones-text">
          OSHA Submission Completed for This Year
        </h4>
        <p className="text-neutral-tones-text font-inter-variable mt-4 text-base">
          Your OSHA report for this year has already been submitted
          successfully.
        </p>
        <div className="mt-4 flex items-center gap-2.5">
          <Button
            href={`/osha-reporting/logs?${currentYear}`}
            otherClasses="bg-brand-fair-orange hover:text-brand-fair-orange hover:border-brand-fair-orange "
            size="small"
          >
            <ReportFileFilledIcon className="h-6 w-6 [&>path]:fill-current" />{' '}
            View Logs
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AlreadySubmittedToOsha;
